//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getInfoByCommunityId } from '@/api/main/admin';
export default {
  props: {
    showDialog: Boolean,
    coordinate: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isCreate: false,
      childData: {},
      mapAPI: './static/gaodeMapNew.html?from=0'
    };
  },
  watch: {
    coordinate: {
      handler: function handler(n, o) {
        console.log(n);
        this.updateCoordinate();

        if (n.longitude && n.latitude) {// this.dingwei()
        }
      },
      deep: true
    },
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      } else {
        this.isCreate = false;
        window.frames['map2'].postMessage({
          type: 'closeMap'
        }, '*');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.listenerEvent); // 清空地图控件
  },
  created: function created() {
    window.addEventListener('message', this.listenerEvent);
    this.init();
  },
  methods: {
    init: function init() {
      this.$set(this.childData, 'longitude', this.coordinate.longitude);
      this.$set(this.childData, 'latitude', this.coordinate.latitude);
      this.isCreate = true;
    },
    getCenterPoint: function getCenterPoint() {
      var _this = this;

      getInfoByCommunityId({}).then(function (res) {
        window.frames['map2'].postMessage({
          type: 'changeCenter',
          lng: res.data.data.lng,
          lat: res.data.data.lat
        }, '*');

        if (_this.childData.longitude && _this.childData.latitude) {
          _this.dingwei();
        } else {
          _this.$set(_this.childData, 'longitude', res.data.data.lng);

          _this.$set(_this.childData, 'latitude', res.data.data.lat);

          _this.dingwei();
        }
      });
    },
    changemap: function changemap(e) {
      console.log(e);
      this.$set(this.childData, 'longitude', e.data.lng);
      this.$set(this.childData, 'latitude', e.data.lat);
    },
    updateCoordinate: function updateCoordinate() {
      this.$set(this.childData, 'longitude', this.coordinate.longitude);
      this.$set(this.childData, 'latitude', this.coordinate.latitude);
    },
    handCreate: function handCreate() {
      var coordinateObj = {
        longitude: this.childData.longitude,
        latitude: this.childData.latitude
      };
      this.$emit('transmitCoordinate', coordinateObj);
      this.$emit('handCancle', false);
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    },
    sw: function sw() {
      window.frames['map2'].postMessage({
        type: 'setPoint'
      }, '*');
    },
    dingwei: function dingwei() {
      var lo = this.childData.longitude;
      var lat = this.childData.latitude;
      var h = '';

      if (!lo || lo === '0' || lo === '1' || !lat) {
        window.frames['map2'].postMessage({
          type: 'reload'
        }, '*');
        return;
      }

      window.frames['map2'].postMessage({
        // 此处在修改数据时进行点位还原
        type: 'editPoint',
        lng: lo,
        lat: lat,
        alt: h
      }, '*');
    },
    clearMap: function clearMap() {
      window.frames['map2'].postMessage({
        type: 'reload'
      }, '*');
    },
    listenerEvent: function listenerEvent(e) {
      var info = this; // 点击记录坐标点事件

      if (e.data.type === 'getPoint') {
        info.changemap(e);
      }

      if (e.data.type === 'loadOver') {
        info.getCenterPoint();
      }
    }
  }
};